import { graphql, useStaticQuery } from 'gatsby';

import React from 'react';
import classNames from 'classnames';
import iconClimatic from '../../../images/icons/picto-info-light-blue.png';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

type ProductSummaryClimaticZoneProps = {
    isOnSale: boolean;
};

export default function ProductSummaryClimaticZone(
    props: ProductSummaryClimaticZoneProps
) {
    const { isOnSale } = props;
    const { t } = useTranslation('templatePages');

    const { currentLocale } = usePageLocalization();

    const summaryClimaticZone: Queries.ProductSummaryClimaticZoneQuery =
        useStaticQuery(graphql`
            query ProductSummaryClimaticZone {
                allProductsJson(
                    filter: {
                        code: { eq: "century_carte-superficie-chauffage" }
                    }
                ) {
                    nodes {
                        documents {
                            fr_CA
                            en_CA
                            en_US
                        }
                    }
                }
            }
        `);

    return (
        <div className={classNames('climatic-zone', { sale: isOnSale })}>
            <div className='climatic-zone-icon'>
                <img className='climatic-icon' src={iconClimatic} alt='' />
            </div>
            <div className='climatic-zone-text'>
                {t('climatic-zone-text')}
                <a
                    rel='noreferrer'
                    target='_blank'
                    href={`/file/${summaryClimaticZone.allProductsJson?.nodes?.[0]?.documents?.[0]?.[currentLocale]}`}
                    className='document hover-underline-to-none'
                >
                    {t('link-gov-inc')}
                </a>
            </div>
        </div>
    );
}
